import styled from 'styled-components'
import {CartLink} from './CartButton.styled'

const flexRules = `
  display: flex;
  flex-wrap: nowrap; 
`

export const Flyout = styled.div`
  display: ${({showFlyout}) => { return showFlyout ? 'block' : 'none' }};
  position: absolute;
  width: 100%;
  right: 0;
  top: 56px;
  z-index: 3;
  box-shadow: 0 6px 25px -6px rgba(78,95,116,0.5);

  &:before {
    background-color: ${props => props.theme.colors.greyscale.white};
    z-index: -1;
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    top: 4px;
    transform: translateY(-50%) rotate(45deg);
    box-shadow: -1px -1px 10px 0 rgba(0,0,0,.2);
    display: block;
    right: 30px;
  }
`

export const Wrapper = styled.div`
  background: ${({theme, dark}) => (dark ? theme.colors.greyscale.light : theme.colors.greyscale.white)};
  padding: 15px 20px;
`

export const List = styled.ul`
  padding: 10px 0;
  margin: 0;
  list-style-type: none;
  
  &:last-of-type {
    padding: 10px 0 0;
  }
  
  &:not(:last-of-type) {
    border-bottom: 1px solid ${({theme}) => theme.colors.greyscale.light};
  }
`

export const ListItem = styled.li`
  ${flexRules}

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`

export const Row = styled.div`
  ${flexRules}
`

export const Column = styled.div`
  line-height: 20px;
  
  &:first-child {
    margin-right: auto;
  }
  
  &:last-child {
    text-align: right;
  }
  
  .shop-header__minicart-flyout-quantity {
    margin-bottom: 15px;
  }    
`

export {CartLink}
